export default "__VITE_ASSET__N$dZBUZe__"